import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import UserTourGuideConstants from "../Constants/UserTourConstants";

class UserTourGuid {
  disablePaticularTour(dataModel) {
    httpRequest(
      config.webServiceURL + "/UserTour/SaveUpdateUserTour",
      "POST",
      JSON.stringify({
        ...dataModel,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: UserTourGuideConstants.DISABLE_TOUR_SUCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: UserTourGuideConstants.DISABLE_TOUR_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new UserTourGuid();
